import React from 'react';

import { Icon, ICONS } from 'core/components/Icon';
import * as AC from 'core/styles/AnimationComponents';

import * as S from './LoadingSpinner.style';

interface IProps {
	size?: number;
}

const LoadingSpinner = ({ size = 30 }: IProps) => (
	<S.InlineFlex>
		<AC.Rotate>
			<Icon name={ICONS.SPINNER} {...{ size }} />
		</AC.Rotate>
	</S.InlineFlex>
);

export default LoadingSpinner;
